import React, { type HTMLAttributes } from 'react';
import { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import { useTranslation } from '@/app/components/translations/Translation';
import { Icon } from '@/app/common/icons/Icon';

type EvoGalleryPhotoCountBadgeProps = {
  /** the total amount of images available in the gallery */
  imageAmount: number;
} & HTMLAttributes<HTMLDivElement>;

/**
 * White pill badge indicating the total amount of photos available.
 * Shown on the last image of the desktop gallery grid, replacing the
 * semi-transparent "show more" overlay.
 */
export default function EvoGalleryPhotoCountBadge({ imageAmount, ...rest }: EvoGalleryPhotoCountBadgeProps) {
  const { t } = useTranslation();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: #ffffff;
        border: 1px solid #d2d1d2;
        border-radius: 8px;
        pointer-events: none;
      `}
      {...rest}
    >
      <Icon category="UI Essentials" name="icon-photo-gallery" size={20} color="iconPrimary" alt="" />
      <Text variant="Body" weight="medium">
        {t('vacation.select.cc.hotel.gallery.photos_count', { count: String(imageAmount) })}
      </Text>
    </div>
  );
}
